import React from 'react';
import { useDrag } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux'; // Added useSelector
import { toggleKeywordActive, markKeywordDeleted } from '../redux/actions';

const ItemTypes = {
  KEYWORD: 'keyword',
};

// Accept columnDefinitions prop
const KeywordItem = ({ id, text, isActive, data, onClick, isSelected, columnDefinitions }) => {
  const dispatch = useDispatch();
  const selectedKeywordIds = useSelector(state => state.keywords.selectedKeywordIds);

  const [{ isDragging }, drag] = useDrag(() => {
    const isItemActuallySelected = selectedKeywordIds.includes(id);
    return {
      type: ItemTypes.KEYWORD,
      item: {
        draggedKeywordId: id,
        text: text,
        data: data,
        isActive: isActive,
        allSelectedIds: isItemActuallySelected ? [...selectedKeywordIds] : [id],
      },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    };
  }, [id, text, isActive, data, selectedKeywordIds]); // Removed isSelected from deps as selectedKeywordIds is the source of truth

  const handleItemClick = (e) => {
    if (e.target.closest('button')) {
      return;
    }
    if (onClick) {
      onClick({ id, originalText: text, data }, e);
    }
  };

  const handleToggleActive = (e) => {
    e.stopPropagation();
    dispatch(toggleKeywordActive(id));
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (window.confirm(`Are you sure you want to delete keyword: "${text}"?`)) {
      dispatch(markKeywordDeleted(id));
    }
  };

  const itemStyle = {
    display: 'flex',
    alignItems: 'center',
    opacity: isDragging ? 0.5 : 1,
    padding: '8px 8px',
    borderBottom: '1px solid #eee',
    backgroundColor: isSelected ? '#cce5ff' : (isActive ? 'white' : '#f0f0f0'),
    color: isActive ? 'inherit' : '#999',
    textDecoration: isActive ? 'none' : 'line-through',
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: '0.9em',
  };

  const columnStyle = {
    padding: '0 5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const keywordColumnStyle = { ...columnStyle, flexGrow: 1, flexShrink: 0, flexBasis: '200px', cursor: 'pointer' }; // Ensure keyword column can shrink but has a basis
  const dataColumnStyle = { ...columnStyle, flexGrow: 0, flexShrink: 0, flexBasis: '100px', textAlign: 'right' }; // Fixed basis for data columns
  const actionsColumnStyle = { ...columnStyle, flexGrow: 0, flexShrink: 0, flexBasis: '150px', textAlign: 'right' }; // Fixed basis for actions

  const buttonStyle = {
    marginLeft: '5px',
    padding: '2px 5px',
    fontSize: '0.9em',
    cursor: 'pointer',
    border: '1px solid #ccc',
    borderRadius: '3px',
  };

  return (
    <div ref={drag} style={itemStyle} onClick={handleItemClick}>
      <span style={keywordColumnStyle} title={text}>{text}</span>
      {(columnDefinitions || []).sort((a, b) => a.displayOrder - b.displayOrder).map(colDef => (
        <span
          key={colDef.id}
          style={dataColumnStyle}
          title={data && data[colDef.id] !== null && data[colDef.id] !== undefined ? String(data[colDef.id]) : ''}
        >
          {data && data[colDef.id] !== null && data[colDef.id] !== undefined ? String(data[colDef.id]) : '-'}
        </span>
      ))}
      <div style={actionsColumnStyle}>
        <button onClick={handleToggleActive} style={{...buttonStyle, backgroundColor: isActive ? '#ffeeba' : '#d4edda' }}>
          {isActive ? 'Deactivate' : 'Activate'}
        </button>
        <button onClick={handleDelete} style={{...buttonStyle, backgroundColor: '#f5c6cb', color: '#721c24' }}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default KeywordItem;
